import { FC, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { ErrorBoundary } from "common/components";
import { MainRoutes, ROUTES } from "common/config";
import Header from "common/components/base/header";
import Logout from "modules/_shared/pages/logout/Logout";
import "./LogoutLayout.scss";

const LogoutLayout: FC = () => {
  return (
    <div className="app-logout-container">
      <Header hideContainer={true} />
      <main className="app-logout-layout">
        <Suspense
          fallback={
            <>
              <div>Fallback</div>
            </>
          }
        >
          <ErrorBoundary>
            <Routes>
              <Route path={ROUTES.DEFAULT} element={<Logout />} />
              <Route path={ROUTES.WILD} element={<Logout />} />
              <Route path={MainRoutes.LOGOUT} element={<Logout />} />
            </Routes>
          </ErrorBoundary>
        </Suspense>
      </main>
    </div>
  );
};

export default LogoutLayout;
